import styled from 'styled-components';

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};
  .ant-select {
    width: 180px;
  }
  .ant-select-selector {
    border: 1px solid ${({ theme }) => theme.colors.black4} !important;
    &:focus {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }
    &:active {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }
  }
  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colors.black4} !important;
  }
  .ant-select-selection-item {
    font-size: 12px;
  }
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FilterOptionLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`;
